const CustomersDirectory = () => {
  return (
    <div>
      <p>Annuaire clients page</p>
    </div>
  );
};

export default CustomersDirectory;
